export const MinusIcon = () => {
  return (
    <svg
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 0.5H10V1.5H5.5H4.5H0V0.5H4.5H5.5Z"
        fill="white"
      />
    </svg>
  );
};
